import axios from 'axios'
import { UrlBase } from './config'

const appNotifications = {}

appNotifications.getAppNotifications = async (token, pagination) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      },
      url: UrlBase + 'users/notifications'
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

appNotifications.getLastAppNotifications = async token => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'users/notifications'
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

appNotifications.markAppNotificationAsViewed = async (token, notificationId) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + `users/notifications/${notificationId}/viewed`
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

export default appNotifications
